import { applySnapshot, flow, types } from "mobx-state-tree";
import moment from "moment";
import { ErrorModel } from "../../components/common/error";
import { MessageModel } from "../../components/common/message";
import { IInput } from "../../utils/common-interface";
import customtypes from "../../utils/mobx-types-helper";
import { ActionModel } from "../org/OrganizeModel";
import { SelectListModel } from "../share";
import { IPlanHeaderModel, PlanHeaderModel } from "../share/PlanModel";
import proposalAPI from "./ProposalService";
import systemHelperAPI from "../systemhelper/SystemHelperService";
import { data } from "jquery";
import userAPI from "../../modules/auth/UserService";

export const ProposalHeaderModel = types
  .model("ProposalHeaderModel", {
    proposalID: customtypes.optional(types.number, 0),
    proposalCode: customtypes.optional(types.string, ""),
    year: customtypes.optional(types.number, 0),
    release: customtypes.optional(types.string, ""),
    createLog: types.maybeNull(ActionModel),
    changeLog: types.maybeNull(ActionModel),
    status: customtypes.optional(types.string, ""),
    organization: types.optional(SelectListModel, {})
  })
  .views((self: any) => ({
    get changeLogActionTime() {
      return self.changeLog ? self.changeLog.actionTime || "-" : "-";
    },
    get changeLogUsername() {
      return self.changeLog ? self.changeLog.userName || "-" : "-";
    },
    get createLogActionTime() {
      return self.createLog ? self.createLog.actionTime || "-" : "-";
    },
    get createLogUsername() {
      return self.createLog ? self.createLog.userName || "-" : "-";
    }
  }))
  .actions((self: any) => ({
    setField: ({ fieldname, value }: IInput) => {
      self[fieldname] = value;
    }
  }));
export type IProposalHeaderModel = typeof ProposalHeaderModel.Type;
export const ProposalModel = types
  .model("ProposalModel", {
    proposalHeader: types.optional(PlanHeaderModel, {}),
    fiveYearPlan: customtypes.optional(PlanHeaderModel, {}),
    newDebtPlan: customtypes.optional(PlanHeaderModel, {}),
    existingDebtPlan: customtypes.optional(PlanHeaderModel, {}),
    financialReport: customtypes.optional(PlanHeaderModel, {}),
    error: types.optional(ErrorModel, {}),
    loading: types.optional(types.boolean, false),
    alert: types.optional(MessageModel, {})
  })
  .views((self: any) => ({
    get fievYearPlanId() {
      return self.fiveYearPlan ? self.fiveYearPlan.planIdView : "";
    },
    get newDebtPlanId() {
      return self.newDebtPlan ? self.newDebtPlan.planIdView : "";
    },
    get existingDebtPlanId() {
      return self.existingDebtPlan ? self.existingDebtPlan.planIdView : "";
    },
    get financialReportPlanId() {
      return self.financialReport ? self.financialReport.planIdView : "";
    }
    //
  }))
  .actions((self: any) => ({
    getProposal: flow(function*() {
      try {
        self.loading = true;
        const result = yield proposalAPI.getProposal(
          self.proposalHeader.planID
        );
        self.setAllField(result.data);
      } catch (e) {
        self.error.tigger = true;
        self.error.code = e.code;
        self.error.title = e.name;
        self.error.message = e.message;
        self.error.technicalStack = e.technicalStack;
        throw e;
      } finally {
        self.loading = false;
      }
    }),
    createProposal: flow(function*() {
      try {
        const result = yield proposalAPI.createProposal({
          proposalHeader: self.proposalHeader,
          fiveYearPlan: self.fiveYearPlan,
          newDebtPlan: self.newDebtPlan,
          existingDebtPlan: self.existingDebtPlan,
          financialReport: self.financialReport
        });
        return result;
      } catch (e) {
        self.error.tigger = true;
        self.error.code = e.code;
        self.error.title = e.name;
        self.error.message = e.message;
        self.error.technicalStack = e.technicalStack;
        throw e;
      } finally {
        //
      }
    }),
    createProposalPlanByList: flow(function*() {
      try {
        const result = yield proposalAPI.create({
          planRelease: self.proposalHeader.planRelease,
          startYear: self.proposalHeader.planYear,
          organizationID: self.proposalHeader.organization.id
        });
        // console.log("createProposalPlanByList==>", result);
        self.proposalHeader.planID = result.data;
      } catch (e) {
        self.error.tigger = true;
        self.error.code = e.code;
        self.error.title = e.name;
        self.error.message = e.message;
        self.error.technicalStack = e.technicalStack;
        throw e;
      }
    }),
    UpdateProposalPlanStatus: flow(function*(isProposing: boolean){
      try {
        self.proposalHeader.emailManagement.isApprove = null;
        self.setReviewComment(self.proposalHeader, "01");
        self.setPlanStatusLogActionTime(self.proposalHeader);
        if (!self.checkPlanStatusAgreeOrApprove(self.fiveYearPlan)) {
          self.setReviewComment(self.fiveYearPlan, "01");
          self.setPlanStatusLogActionTime(self.fiveYearPlan);
        }
        if (!self.checkPlanStatusAgreeOrApprove(self.newDebtPlan)) {
          self.setReviewComment(self.newDebtPlan, "01");
          self.setPlanStatusLogActionTime(self.newDebtPlan);
        }
        if (!self.checkPlanStatusAgreeOrApprove(self.existingDebtPlan)) {
          self.setReviewComment(self.existingDebtPlan, "01");
          self.setPlanStatusLogActionTime(self.existingDebtPlan);
        }
        if (!self.checkPlanStatusAgreeOrApprove(self.financialReport)) {
          self.setReviewComment(self.financialReport, "01");
          self.setPlanStatusLogActionTime(self.financialReport);
        }
        yield proposalAPI.updateProposal(
          {
            proposalHeader: self.proposalHeader,
            fiveYearPlan: self.fiveYearPlan,
            newDebtPlan: self.newDebtPlan,
            existingDebtPlan: self.existingDebtPlan,
            financialReport: self.financialReport
          },
          `isProposing=${isProposing}`
        );
        self.alert.tigger = true;
        self.alert.title = "บันทึกข้อมูลสำเร็จแล้วค่ะ";
        self.alert.message = "ข้อมูลถูกแก้ไขเรียบร้อยแล้ว";
        yield self.getProposal();
      } catch (e) {
        self.error.tigger = true;
        self.error.code = e.code;
        self.error.title = e.name;
        self.error.message = e.message;
        self.error.technicalStack = e.technicalStack;
        throw e;
      } finally {
        //
      }
    }),
    presentProposalToManageMent: flow(function*(isProposing: boolean, email: string){
      try {
        self.proposalHeader.emailManagement.approveEmail = email;
        self.proposalHeader.emailManagement.isApprove = "01";
        self.setReviewComment(self.proposalHeader, "01");
        self.setPlanStatusLogActionTime(self.proposalHeader);
        if (!self.checkPlanStatusAgreeOrApprove(self.fiveYearPlan)) {
          self.setReviewComment(self.fiveYearPlan, "01");
          self.setPlanStatusLogActionTime(self.fiveYearPlan);
        }
        if (!self.checkPlanStatusAgreeOrApprove(self.newDebtPlan)) {
          self.setReviewComment(self.newDebtPlan, "01");
          self.setPlanStatusLogActionTime(self.newDebtPlan);
        }
        if (!self.checkPlanStatusAgreeOrApprove(self.existingDebtPlan)) {
          self.setReviewComment(self.existingDebtPlan, "01");
          self.setPlanStatusLogActionTime(self.existingDebtPlan);
        }
        if (!self.checkPlanStatusAgreeOrApprove(self.financialReport)) {
          self.setReviewComment(self.financialReport, "01");
          self.setPlanStatusLogActionTime(self.financialReport);
        }
        yield proposalAPI.updateProposal(
          {
            proposalHeader: self.proposalHeader,
            fiveYearPlan: self.fiveYearPlan,
            newDebtPlan: self.newDebtPlan,
            existingDebtPlan: self.existingDebtPlan,
            financialReport: self.financialReport
          },
          `isProposing=${isProposing}`
        );
        self.alert.tigger = true;
        self.alert.title = "บันทึกข้อมูลสำเร็จแล้วค่ะ";
        self.alert.message = "ข้อมูลถูกแก้ไขเรียบร้อยแล้ว";
        yield self.getProposal();
      } catch (e) {
        self.error.tigger = true;
        self.error.code = e.code;
        self.error.title = e.name;
        self.error.message = e.message;
        self.error.technicalStack = e.technicalStack;
        throw e;
      } finally {
        //
      }
    }),
    presentProposal: flow(function*() {
      try {
        self.proposalHeader.emailManagement.isApprove = "02";
        self.setReviewComment(self.proposalHeader, "02");
        self.setPlanStatusLogActionTime(self.proposalHeader);
        if (!self.checkPlanStatusAgreeOrApprove(self.fiveYearPlan)) {
          self.setReviewComment(self.fiveYearPlan, "02");
          self.setPlanStatusLogActionTime(self.fiveYearPlan);
        }
        if (!self.checkPlanStatusAgreeOrApprove(self.newDebtPlan)) {
          self.setReviewComment(self.newDebtPlan, "02");
          self.setPlanStatusLogActionTime(self.newDebtPlan);
        }
        if (!self.checkPlanStatusAgreeOrApprove(self.existingDebtPlan)) {
          self.setReviewComment(self.existingDebtPlan, "02");
          self.setPlanStatusLogActionTime(self.existingDebtPlan);
        }
        if (!self.checkPlanStatusAgreeOrApprove(self.financialReport)) {
          self.setReviewComment(self.financialReport, "02");
          self.setPlanStatusLogActionTime(self.financialReport);
        }

        yield proposalAPI.updateProposal(
          {
            proposalHeader: self.proposalHeader,
            fiveYearPlan: self.fiveYearPlan,
            newDebtPlan: self.newDebtPlan,
            existingDebtPlan: self.existingDebtPlan,
            financialReport: self.financialReport
          },
          "isProposing=true"
        );
        self.alert.tigger = true;
        self.alert.title = "บันทึกข้อมูลสำเร็จแล้วค่ะ";
        self.alert.message = "ข้อมูลถูกแก้ไขเรียบร้อยแล้ว";
        yield self.getProposal();
      } catch (e) {
        self.error.tigger = true;
        self.error.code = e.code;
        self.error.title = e.name;
        self.error.message = e.message;
        self.error.technicalStack = e.technicalStack;
        throw e;
      } finally {
        //
      }
    }),
    agreeToProposal: flow(function*() {
      try {
        self.setReviewComment(self.proposalHeader, "04");
        self.setReviewComment(self.fiveYearPlan, "05");
        self.setReviewComment(self.newDebtPlan, "05");
        self.setReviewComment(self.existingDebtPlan, "05");
        self.setReviewComment(self.financialReport, "05");
        self.setPlanStatusLogActionTime(self.proposalHeader);
        self.setPlanStatusLogActionTime(self.fiveYearPlan);
        self.setPlanStatusLogActionTime(self.newDebtPlan);
        self.setPlanStatusLogActionTime(self.existingDebtPlan);
        self.setPlanStatusLogActionTime(self.financialReport);
        yield proposalAPI.updateProposal({
          proposalHeader: self.proposalHeader,
          fiveYearPlan: self.fiveYearPlan,
          newDebtPlan: self.newDebtPlan,
          existingDebtPlan: self.existingDebtPlan,
          financialReport: self.financialReport
        });
        self.alert.tigger = true;
        self.alert.title = "บันทึกข้อมูลสำเร็จแล้วค่ะ";
        self.alert.message = "ข้อมูลถูกแก้ไขเรียบร้อยแล้ว";
        yield self.getProposal();
      } catch (e) {
        self.error.tigger = true;
        self.error.code = e.code;
        self.error.title = e.name;
        self.error.message = e.message;
        self.error.technicalStack = e.technicalStack;
        throw e;
      } finally {
        //
      }
    }),
    approveToProposal: flow(function*() {
      try {
        self.setReviewComment(self.proposalHeader, "05");
        self.setReviewComment(self.fiveYearPlan, "06");
        self.setReviewComment(self.newDebtPlan, "06");
        self.setReviewComment(self.existingDebtPlan, "06");
        self.setReviewComment(self.financialReport, "06");
        self.setPlanStatusLogActionTime(self.proposalHeader);
        self.setPlanStatusLogActionTime(self.fiveYearPlan);
        self.setPlanStatusLogActionTime(self.newDebtPlan);
        self.setPlanStatusLogActionTime(self.existingDebtPlan);
        self.setPlanStatusLogActionTime(self.financialReport);
        yield proposalAPI.updateProposal({
          proposalHeader: self.proposalHeader,
          fiveYearPlan: self.fiveYearPlan,
          newDebtPlan: self.newDebtPlan,
          existingDebtPlan: self.existingDebtPlan,
          financialReport: self.financialReport
        });
        self.alert.tigger = true;
        self.alert.title = "บันทึกข้อมูลสำเร็จแล้วค่ะ";
        self.alert.message = "ข้อมูลถูกแก้ไขเรียบร้อยแล้ว";
        yield self.getProposal();
      } catch (e) {
        self.error.tigger = true;
        self.error.code = e.code;
        self.error.title = e.name;
        self.error.message = e.message;
        self.error.technicalStack = e.technicalStack;
        throw e;
      } finally {
        //
      }
    }),
    setReviewComment: (header: IPlanHeaderModel, status: string) => {
      header.reviewComment.reviewDate = moment().format();
      header.reviewComment.resultStatus = status;
      header.reviewComment.resultDescription = header.reviewComment.resultDescription;
      header.reviewComment.comment = header.reviewComment.comment;
    },
    setPlanStatusLogActionTime: (header: IPlanHeaderModel) => {
      const { actionTime } = header.planStatusLog;
      header.planStatusLog = {
        ...header.planStatusLog,
        actionTime: actionTime ? actionTime : header.reviewComment.reviewDate
      };
    },
    updateFiveYearPlan: flow(function*() {
      try {
        if (self.checkPlanStatusForWaiting(self.fiveYearPlan)) {
          self.setReviewComment(self.proposalHeader, "03");
        }
        self.fiveYearPlan.reviewComment.reviewDate = moment().format();
        self.fiveYearPlan.planStatusLog.actionTime = moment().format();
        yield proposalAPI.updateProposal({
          proposalHeader: self.proposalHeader,
          fiveYearPlan: self.fiveYearPlan
        });
        self.alert.tigger = true;
        self.alert.title = "บันทึกข้อมูลสำเร็จแล้วค่ะ";
        self.alert.message = "ข้อมูลถูกแก้ไขเรียบร้อยแล้ว";
        yield self.getProposal();
      } catch (e) {
        self.error.tigger = true;
        self.error.code = e.code;
        self.error.title = e.name;
        self.error.message = e.message;
        self.error.technicalStack = e.technicalStack;
        throw e;
      } finally {
        //
      }
    }),
    checkApproveStatusFromManagement: (status: string[]) => {
      return status.includes(self.proposalHeader.emailManagement.isApprove);
    },
    checkPlanStatusForWaiting: (plan: IPlanHeaderModel) => {
      return ["03", "04"].includes(plan.reviewComment.resultStatus);
    },
    checkPlanStatusAgreeOrApprove: (plan: IPlanHeaderModel) => {
      return ["05", "06"].includes(plan.reviewComment.resultStatus);
    },
    checkProposalStatus: (status: string[]) => {
      return status.includes(self.proposalHeader.reviewComment.resultStatus);
    },
    checkPlanStatus: (plan: IPlanHeaderModel) => {
      return status.includes(self.proposalHeader.reviewComment.resultStatus);
    },
    updateNewDebtPlan: flow(function*() {
      try {
        if (self.checkPlanStatusForWaiting(self.newDebtPlan)) {
          self.setReviewComment(self.proposalHeader, "03");
        }
        self.newDebtPlan.reviewComment.reviewDate = moment().format();
        self.newDebtPlan.planStatusLog.actionTime = moment().format();
        yield proposalAPI.updateProposal({
          proposalHeader: self.proposalHeader,
          newDebtPlan: self.newDebtPlan
        });
        self.alert.tigger = true;
        self.alert.title = "บันทึกข้อมูลสำเร็จแล้วค่ะ";
        self.alert.message = "ข้อมูลถูกแก้ไขเรียบร้อยแล้ว";
        yield self.getProposal();
      } catch (e) {
        self.error.tigger = true;
        self.error.code = e.code;
        self.error.title = e.name;
        self.error.message = e.message;
        self.error.technicalStack = e.technicalStack;
        throw e;
      } finally {
        //
      }
    }),
    updateExistingPlan: flow(function*() {
      try {
        if (self.checkPlanStatusForWaiting(self.existingDebtPlan)) {
          self.setReviewComment(self.proposalHeader, "03");
        }
        self.existingDebtPlan.reviewComment.reviewDate = moment().format();
        self.existingDebtPlan.planStatusLog.actionTime = moment().format();
        yield proposalAPI.updateProposal({
          proposalHeader: self.proposalHeader,
          existingDebtPlan: self.existingDebtPlan
        });
        self.alert.tigger = true;
        self.alert.title = "บันทึกข้อมูลสำเร็จแล้วค่ะ";
        self.alert.message = "ข้อมูลถูกแก้ไขเรียบร้อยแล้ว";
        yield self.getProposal();
      } catch (e) {
        self.error.tigger = true;
        self.error.code = e.code;
        self.error.title = e.name;
        self.error.message = e.message;
        self.error.technicalStack = e.technicalStack;
        throw e;
      } finally {
        //
      }
    }),
    updateFinancialReport: flow(function*() {
      try {
        if (self.checkPlanStatusForWaiting(self.financialReport)) {
          self.setReviewComment(self.proposalHeader, "03");
        }
        self.financialReport.reviewComment.reviewDate = moment().format();
        self.financialReport.planStatusLog.actionTime = moment().format();
        yield proposalAPI.updateProposal({
          proposalHeader: self.proposalHeader,
          financialReport: self.financialReport
        });
        self.alert.tigger = true;
        self.alert.title = "บันทึกข้อมูลสำเร็จแล้วค่ะ";
        self.alert.message = "ข้อมูลถูกแก้ไขเรียบร้อยแล้ว";
        yield self.getProposal();
      } catch (e) {
        self.error.tigger = true;
        self.error.code = e.code;
        self.error.title = e.name;
        self.error.message = e.message;
        self.error.technicalStack = e.technicalStack;
        throw e;
      } finally {
        //
      }
    }),
    sendEmailToManageMent: flow(function*(textSubjectStaff: string,textEmailManagement :string, email :string) {
      try {
        self.loading = true;
        yield systemHelperAPI.createSendMail({
          fromEmail: "noreply@pdmo.go.th",
          toEmail: email,
          subject: textSubjectStaff,
          body: textEmailManagement
        });
        self.alert.tigger = true;
        self.alert.title = "บันทึกข้อมูลสำเร็จและส่ง Email เรียบร้อยแล้วค่ะ";
        self.alert.message = "ข้อมูลถูกแก้ไขเรียบร้อยแล้ว";
      } catch (e) {
        self.error.tigger = true;
        self.error.code = e.code;
        self.error.title = e.name;
        self.error.message = e.message;
        self.error.technicalStack = e.technicalStack;
        throw e;
      } finally {
        self.loading = false;
      }
      
    }),
    sendEmailPresentProposal: flow(function*(textSubjectOrg: string,textEmailOrg :string ,textSubjectStaff: string,textEmailStff :string) {
      try {
        self.loading = true;
        if(self.proposalHeader && self.proposalHeader.createLog){
            if(self.proposalHeader.createLog.userID){
             const result= yield userAPI.getUser(self.proposalHeader.createLog.userID);
             if(result.data.userProfile){
               const userdata =result.data.userProfile;
               console.log('userdata',userdata)
                if(userdata.email){
                  yield systemHelperAPI.createSendMail({
                    fromEmail: "noreply@pdmo.go.th",
                    toEmail: `${userdata.email}`,
                    subject: textSubjectOrg,
                    body: textEmailOrg
                  });
                }
                const resultListStaff= yield userAPI.searchUser({
                    "roles":["PDMOUSER"],
                    "pageSize": 1000
                });
                // console.log('resultListStaff',resultListStaff)
                // var countList=0;
                // var listEmail=[];
                if(resultListStaff.isCompleted){
                  const listStaffPDMO= resultListStaff.data;
                  if(listStaffPDMO && listStaffPDMO.length >0 ){
                    for (var i = 0; i < listStaffPDMO.length; i++) {
                      if(listStaffPDMO[i].id){
                        const resultUserProfileStaff= yield userAPI.getUser(listStaffPDMO[i].id);
                        // console.log('resultUserProfileStaff',resultUserProfileStaff)
                        if(resultUserProfileStaff.data){
                          const userProfileData =resultUserProfileStaff.data.userProfile;
                          const permissionsData =resultUserProfileStaff.data.permissions;
                          // console.log('permissionsData',permissionsData)
                          if(permissionsData && permissionsData.length >0){
                            for (var j = 0; j < permissionsData.length; j++) {
                              if(permissionsData[j].permissionGroupCode== "PROP"){
                              //  console.log('permissionsData[j].permissionGroupCode== "PROP"');
                                for (var k = 0; k < permissionsData[j].userPermissions.length; k++) {
                                  if(permissionsData[j].userPermissions[k].permissionCode== "PP006" && permissionsData[j].userPermissions[k].isSelected== true){
                                    // console.log('userProfileData PROP PP006',userProfileData)
                                    if(userProfileData.email){
                                      // console.log('sendEmailStaff',userProfileData.email)
                                      // listEmail.push(userProfileData.email);
                                        yield systemHelperAPI.createSendMail({
                                          fromEmail: "noreply@pdmo.go.th",
                                          toEmail: userProfileData.email,
                                          subject: textSubjectStaff,
                                          body: textEmailStff
                                        });
                                    }
                                    // countList=countList+1;
                                }
                              }
                              }

                            }
                          }
                        }
                      }
                  } 
                  }
                }
                // console.log('countList',countList);
                // console.log('listEmail',listEmail);
               
             }
            }
          }
        self.alert.tigger = true;
        self.alert.title = "บันทึกข้อมูลสำเร็จและส่ง Email เรียบร้อยแล้วค่ะ";
        self.alert.message = "ข้อมูลถูกแก้ไขเรียบร้อยแล้ว";
      } catch (e) {
        self.error.tigger = true;
        self.error.code = e.code;
        self.error.title = e.name;
        self.error.message = e.message;
        self.error.technicalStack = e.technicalStack;
        throw e;
      } finally {
        self.loading = false;
      }
    }),
    sendEmailEditPlan: flow(function*(textSubject: string,textEmail :string ,) {
      try {
        self.loading = true;
        // console.log('sendEmailEditPlan',self.checkPlanStatusForWaiting(self.fiveYearPlan));
        if (self.checkPlanStatusForWaiting(self.fiveYearPlan) || self.checkPlanStatusForWaiting(self.newDebtPlan)|| self.checkPlanStatusForWaiting(self.existingDebtPlan) || self.checkPlanStatusForWaiting(self.financialReport)) {
        if(self.proposalHeader && self.proposalHeader.createLog){
          if(self.proposalHeader.createLog.userID){
           const result= yield userAPI.getUser(self.proposalHeader.createLog.userID);
           if(result.data.userProfile){
             const userdata =result.data.userProfile;
              if(userdata.email){
                yield systemHelperAPI.createSendMail({
                  fromEmail: "noreply@pdmo.go.th",
                  toEmail: `${userdata.email}`,
                  subject: textSubject,
                  body: textEmail
                });
              }
           }
          }
        }
      }
        self.alert.tigger = true;
        self.alert.title = "บันทึกข้อมูลสำเร็จและส่ง Email เรียบร้อยแล้วค่ะ";
        self.alert.message = "ข้อมูลถูกแก้ไขเรียบร้อยแล้ว";
      } catch (e) {
        self.error.tigger = true;
        self.error.code = e.code;
        self.error.title = e.name;
        self.error.message = e.message;
        self.error.technicalStack = e.technicalStack;
        throw e;
      } finally {
        self.loading = false;
      }
    }),
    addFiveYearPlan: flow(function*() {
      try {
        yield proposalAPI.addPlan(
          self.proposalHeader.planID,
          self.fiveYearPlan.planID
        );
        yield self.getProposal();
        self.alert.tigger = true;
        self.alert.title = "บันทึกข้อมูลสำเร็จแล้วค่ะ";
        self.alert.message = "ข้อมูลถูกแก้ไขเรียบร้อยแล้ว";
      } catch (e) {
        self.error.tigger = true;
        self.error.code = e.code;
        self.error.title = e.name;
        self.error.message = e.message;
        self.error.technicalStack = e.technicalStack;
        throw e;
      }
    }),
    removeFiveYearPlan: flow(function*() {
      try {
        yield proposalAPI.removePlanFromProposal(
          `${self.proposalHeader.planID}/plan/MP`
        );
        yield self.getProposal();
        self.alert.tigger = true;
        self.alert.title = "บันทึกข้อมูลสำเร็จแล้วค่ะ";
        self.alert.message = "ข้อมูลถูกแก้ไขเรียบร้อยแล้ว";
      } catch (e) {
        self.error.tigger = true;
        self.error.code = e.code;
        self.error.title = e.name;
        self.error.message = e.message;
        self.error.technicalStack = e.technicalStack;
        throw e;
      }
    }),
    addNewDebtPlan: flow(function*() {
      try {
        yield proposalAPI.addPlan(
          self.proposalHeader.planID,
          self.newDebtPlan.planID
        );
        yield self.getProposal();
        self.alert.tigger = true;
        self.alert.title = "บันทึกข้อมูลสำเร็จแล้วค่ะ";
        self.alert.message = "ข้อมูลถูกแก้ไขเรียบร้อยแล้ว";
      } catch (e) {
        self.error.tigger = true;
        self.error.code = e.code;
        self.error.title = e.name;
        self.error.message = e.message;
        self.error.technicalStack = e.technicalStack;
        throw e;
      }
    }),
    removeNewDebtPlan: flow(function*() {
      try {
        yield proposalAPI.removePlanFromProposal(
          `${self.proposalHeader.planID}/plan/NP`
        );
        yield self.getProposal();
        self.alert.tigger = true;
        self.alert.title = "บันทึกข้อมูลสำเร็จแล้วค่ะ";
        self.alert.message = "ข้อมูลถูกแก้ไขเรียบร้อยแล้ว";
      } catch (e) {
        self.error.tigger = true;
        self.error.code = e.code;
        self.error.title = e.name;
        self.error.message = e.message;
        self.error.technicalStack = e.technicalStack;
        throw e;
      }
    }),
    addExistingPlan: flow(function*() {
      try {
        yield proposalAPI.addPlan(
          self.proposalHeader.planID,
          self.existingDebtPlan.planID
        );
        yield self.getProposal();
        self.alert.tigger = true;
        self.alert.title = "บันทึกข้อมูลสำเร็จแล้วค่ะ";
        self.alert.message = "ข้อมูลถูกแก้ไขเรียบร้อยแล้ว";
      } catch (e) {
        self.error.tigger = true;
        self.error.code = e.code;
        self.error.title = e.name;
        self.error.message = e.message;
        self.error.technicalStack = e.technicalStack;
        throw e;
      }
    }),
    removeExistingDebtPlan: flow(function*() {
      try {
        yield proposalAPI.removePlanFromProposal(
          `${self.proposalHeader.planID}/plan/EP`
        );
        yield self.getProposal();
        self.alert.tigger = true;
        self.alert.title = "บันทึกข้อมูลสำเร็จแล้วค่ะ";
        self.alert.message = "ข้อมูลถูกแก้ไขเรียบร้อยแล้ว";
      } catch (e) {
        self.error.tigger = true;
        self.error.code = e.code;
        self.error.title = e.name;
        self.error.message = e.message;
        self.error.technicalStack = e.technicalStack;
        throw e;
      }
    }),
    addFinancialReport: flow(function*() {
      try {
        yield proposalAPI.addPlan(
          self.proposalHeader.planID,
          self.financialReport.planID
        );
        yield self.getProposal();
        self.alert.tigger = true;
        self.alert.title = "บันทึกข้อมูลสำเร็จแล้วค่ะ";
        self.alert.message = "ข้อมูลถูกแก้ไขเรียบร้อยแล้ว";
      } catch (e) {
        self.error.tigger = true;
        self.error.code = e.code;
        self.error.title = e.name;
        self.error.message = e.message;
        self.error.technicalStack = e.technicalStack;
        throw e;
      }
    }),
    removeFinancialReport: flow(function*() {
      try {
        yield proposalAPI.removePlanFromProposal(
          `${self.proposalHeader.planID}/plan/RP`
        );
        yield self.getProposal();
        self.alert.tigger = true;
        self.alert.title = "บันทึกข้อมูลสำเร็จแล้วค่ะ";
        self.alert.message = "ข้อมูลถูกแก้ไขเรียบร้อยแล้ว";
      } catch (e) {
        self.error.tigger = true;
        self.error.code = e.code;
        self.error.title = e.name;
        self.error.message = e.message;
        self.error.technicalStack = e.technicalStack;
        throw e;
      }
    }),
    setProposalId: (id: number) => {
      self.proposalHeader.planID = id;
    },
    setFiveYearPlanId: (id: number) => {
      self.fiveYearPlan.planID = id;
    },
    setNewDebtPlanId: (id: number) => {
      self.newDebtPlan.planID = id;
    },
    setExistingDebtPlanId: (id: number) => {
      self.existingDebtPlan.planID = id;
    },
    setFinancialReportId: (id: number) => {
      self.financialReport.planID = id;
    },
    setField: ({ fieldname, value }: IInput) => {
      self[fieldname] = value;
    },
    resetAll: () => {
      applySnapshot(self, {});
    },
    setAllField: (data: any) => {
      Object.keys(data).forEach((key) => {
        try {
          self[key] = data[key];
        } catch (e) {
          console.log("exception on mapping key:", key);
        }
      });
    },
  }));
export type IProposalModel = typeof ProposalModel.Type;
